import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Typography,
  TextField,
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton
} from '@material-ui/core';


interface IQuoteSeriesNameModalProps {
  defaultValue?: string,
  validNames?: Array<string>,
  title: string,
  open: boolean,
  setOpen: (_value: boolean | ((_prevVar: boolean) => boolean)) => void,
  onSave: (_value) => void,
}

const QuoteSeriesNameModal = ({
  defaultValue = '',
  validNames = [],
  title,
  open,
  setOpen,
  onSave
}: IQuoteSeriesNameModalProps) => {
  const [values, setValues] = useState({
    value: defaultValue,
    error: '',
    touched: false
  });

  const {
    value,
    error,
    touched
  } = values;

  const {
    quotePlan
  } = useSelector((state: IReduxState) => state.quote);

  const handleChangeSeriesName = (newName) => {
    const isDuplicateName = quotePlan.some((series) => {
      if (
        series.name === defaultValue ||
        validNames.includes(series.name)
      ) {
        return false;
      }

      return series.name === newName;
    });

    if (isDuplicateName) {
      const error = 'Treatment Series name is already exist';
      setValues((prev) => ({ ...prev, value: newName,  touched: true, error }));
    } else if (!isDuplicateName && error.length) {
      setValues((prev) => ({ ...prev, value: newName, touched: true, error: '' }));
    } else {
      setValues((prev) => ({ ...prev, value: newName, touched: true}));
    }
  };

  const handleClose = () => {
    setValues({
      value: defaultValue,
      error: '',
      touched: false
    });
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="info-dialog"
      PaperProps={{
        className: 'border-radius-6 p-3'
      }}
      fullWidth
      maxWidth={'sm'}
    >
      <DialogTitle id="custom-dialog" className="flex-column w-full p-3">
        <div className="flex justify-between">
          <Typography variant="h5" className="uppercase">
            {title}
          </Typography>
          <IconButton
            size="small"
            onClick={handleClose}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="px-8 pt-5 pb-10">
        <div className="font-bold text-12">
          {'Name of Treatment Series'}
        </div>
        <TextField
          required
          fullWidth
          variant="outlined"
          name="label"
          placeholder="Type Name..."
          className="w-full"
          value={value}
          onChange={({target: {value}}) => handleChangeSeriesName(value)}
          error={touched && (Boolean(error) || !value.trim().length)}
          helperText={touched && (error || (!value.trim().length && 'Field is Required'))}
        />
      </DialogContent>
      <DialogActions className="justify-between">
        <Button
          variant="outlined"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={!value.trim().length || !!error.length}
          onClick={() => {
            onSave(value);
            setValues({
              ...values,
              error: '',
              touched: false
            });
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuoteSeriesNameModal;
